import { Link, useNavigate } from "react-router-dom";
import { Plus, User, LogOut, MessageSquare, Heart, LayoutDashboard } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const ACCOUNT_LINKS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, id: "dashboard" },
  { to: "/favorites", label: "Favorites", icon: Heart, id: "favorites" },
  { to: "/messages", label: "Messages", icon: MessageSquare, id: "messages" },
];

function UserMenu({ user, onLogout }) {
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="user-menu-btn" className="border-2 border-black px-3 py-2 hover:bg-black hover:text-white flex items-center gap-2">
          <User size={14} strokeWidth={2.5} />
          <span className="max-w-[100px] truncate normal-case">{user.name || user.email}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none border-2 border-black hard-shadow-sm font-mono-data uppercase text-xs">
        {ACCOUNT_LINKS.map(({ to, label, icon: Icon, id }) => (
          <DropdownMenuItem key={id} onClick={() => navigate(to)} data-testid={`menu-${id}`} className="rounded-none cursor-pointer">
            <Icon size={14} className="mr-2" /> {label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onLogout} data-testid="menu-logout" className="rounded-none cursor-pointer text-[#FF0000]">
          <LogOut size={14} className="mr-2" /> Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function DesktopNav({ user, onLogout }) {
  return (
    <nav className="hidden md:flex items-center gap-3 font-mono-data text-xs uppercase">
      <Link to="/post" data-testid="post-ad-btn" className="bg-[#0000EE] text-white px-4 py-2 border-2 border-[#0000EE] hover:bg-[#0000AA] hover:border-[#0000AA] no-underline hover:no-underline flex items-center gap-1">
        <Plus size={14} strokeWidth={3} /> Post Ad
      </Link>
      {user ? <UserMenu user={user} onLogout={onLogout} /> : (
        <>
          <Link to="/login" data-testid="header-login-link" className="border-2 border-black px-3 py-2 hover:bg-black hover:text-white no-underline hover:no-underline text-black">Log In</Link>
          <Link to="/register" data-testid="header-register-link" className="border-2 border-black px-3 py-2 bg-black text-white hover:bg-[#0000EE] hover:border-[#0000EE] no-underline hover:no-underline">Sign Up</Link>
        </>
      )}
    </nav>
  );
}
